export const CANADIAN_PROVINCES_AND_TERRITORIES = [
  'Alberta',
  'Colombie-Britannique',
  'Île-du-Prince-Édouard',
  'Manitoba',
  'Nouveau-Brunswick',
  'Nouvelle-Écosse',
  'Nunavut',
  'Ontario',
  'Québec',
  'Saskatchewan',
  'Terre-Neuve-et-Labrador',
  'Territoires du Nord-Ouest',
  'Yukon',
];
